import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { BaseApiTemplateService, Core2Config, ApiVisa } from '../../shared';
import { ApiResponseModel } from '../../shared/api-response.model';


@Injectable({
  providedIn: 'root'
})
export class CashAdjustmentService extends BaseApiTemplateService<any> {

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/cash-adjustments/backoffice-ep";
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/cash-adjustments/backoffice-ep";
        this.httpClient = http;
      }

      public createTemp(payload: any, apiVisa: ApiVisa) {
        let apiUrl = apiVisa.api_domain_url +Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/cash-adjustments/temp/backoffice-ep"
        return this.httpClient.post<ApiResponseModel<any>>(
          apiUrl,
          payload,
          this.getHttpHeader(apiVisa)
        );
      }
    
}